import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { Modal } from 'antd';
import { memo } from 'react';

type Props = {
  openConfirm: boolean;
  setOpenConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  handleDeleteImage: () => void;
  title: string;
  isInProgram?: boolean;
};
function ModalDeleteImage({
  openConfirm,
  setOpenConfirm,
  handleDeleteImage,
  title,
  isInProgram,
}: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      zIndex={1005}
      centered
      visible={openConfirm}
      onOk={() => setOpenConfirm(false)}
      onCancel={() => setOpenConfirm(false)}
      className="modal_confirm_delete"
    >
      <div className="flex flex-col">
        <div className="flex flex-col py-[20px] px-4 justify-center items-center">
          {isInProgram ? (
            <>
              <span className="text-[#1D2939] text-base font-notosans-700">
                {t('DELETE_IMAGE')}
              </span>
              <span className="text-[#1D2939] text-base text-center">
                {t('IMAGE_WAS_IN_PROGRAM')}
              </span>
              <span className="text-[#1D2939] text-base text-center">
                {t('THIS_PROGRAM_WAS_ALSO_DELETED')}
              </span>
              <span className="text-[#1D2939] text-base">
                {t('ARE_YOU_SURE_WANT_TO_DELETE_IT')}
              </span>
            </>
          ) : (
            <>
              <span className="text-[#1D2939] text-base font-notosans-700">
                {t('DELETE_IMAGE')}
              </span>
              <span className="text-[#1D2939] text-base text-center">{title}</span>
              <span className="text-[#1D2939] text-base">{t('R_U_SURE')}</span>
            </>
          )}
        </div>
        <div className="grid grid-cols-2 gap-2 p-3 border-t border-border-gray">
          <button
            onClick={() => setOpenConfirm(false)}
            className="flex items-center justify-center text-base border border-solid rounded-md border-border-gray h-11 notosans_medium text-primary"
          >
            {t('CANCEL')}
          </button>
          <button
            onClick={handleDeleteImage}
            className="border border-solid border-[#F04438] rounded-md h-11 flex items-center justify-center"
          >
            <span>{cts.deleteIcon}</span>
            <span className=" text-base text-[#F04438] notosans_medium">{t('DELETE')}</span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
export default memo(ModalDeleteImage);
